var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 2.33203H4.66671C2.66671 2.33203 1.33337 3.33203 1.33337 5.66536V10.332C1.33337 12.6654 2.66671 13.6654 4.66671 13.6654H11.3334C13.3334 13.6654 14.6667 12.6654 14.6667 10.332V5.66536C14.6667 3.33203 13.3334 2.33203 11.3334 2.33203ZM11.6467 6.39203L9.56004 8.0587C9.12004 8.41203 8.56004 8.58536 8.00004 8.58536C7.44004 8.58536 6.87337 8.41203 6.44004 8.0587L4.35337 6.39203C4.14004 6.2187 4.10671 5.8987 4.27337 5.68536C4.44671 5.47203 4.76004 5.43203 4.97337 5.60536L7.06004 7.27203C7.56671 7.6787 8.42671 7.6787 8.93337 7.27203L11.02 5.60536C11.2334 5.43203 11.5534 5.46536 11.72 5.68536C11.8934 5.8987 11.86 6.2187 11.6467 6.39203Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSms);
export default __webpack_public_path__ + "static/media/info_sms.0d1afc5161deb6d6b45cb5a19419ba27.svg";
export { ForwardRef as ReactComponent };